import React, { ReactElement } from "react";
import styles from "./styles.module.scss";
export default function MainImage(): ReactElement {
    return <div className={styles["mainBannerWrapper"]}></div>;
}
